import React, { useEffect } from 'react'
import Subtitle from '../components/UI/Subtitle'
import DocumentsList from '../components/DocumentsList'
import { FormattedMessage } from "react-intl"
import DashboardLinks from '../components/Navigation/DashboardLinks'

const Documents = () => {

    return (
        <>
            <DashboardLinks />
            <div className="p-4">
                <Subtitle><FormattedMessage id="app.privateMenu.documents" defaultMessage="Documents" />:</Subtitle>
                <hr className='mt-4 mb-4'></hr>
                <DocumentsList />
            </div>
        </>
    )
}

export default Documents